var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-card__footer"},[_c('post-author',{staticClass:"post-card__author",attrs:{"author":_vm.author}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }